// Tracks in-flight HTTP upload promises keyed by questionId. The role-based
// assessment dispatches video uploads from MediaRecorder.onstop and must
// guarantee on auto-submit that every dispatched POST has settled (so the
// backend's /students/assessments/uploadVideo handler has had a chance to
// write its StudentAnswer row) before the assessment finalises.
//
// Mirrors the inflightVideoUploadRef pattern in Communicationassmt, generalised
// to a Map so role-based's multi-question flow is supported.

export function createInflightUploads() {
  const inflight = new Map();

  function track(questionId, promise) {
    inflight.set(questionId, promise);
    const settle = () => {
      // Only clear if this is still the tracked promise — a re-record may
      // have overwritten with a newer upload before this one resolved.
      if (inflight.get(questionId) === promise) inflight.delete(questionId);
    };
    Promise.resolve(promise).then(settle, settle);
    return promise;
  }

  function size() {
    return inflight.size;
  }

  function drain() {
    const values = [...inflight.values()];
    if (values.length === 0) return Promise.resolve([]);
    return Promise.allSettled(values);
  }

  function snapshot() {
    return [...inflight.keys()];
  }

  return { track, drain, size, snapshot };
}
